/* =====================================================================
   Bluewud saved items — the single storage core behind the wishlist
   hearts AND the cart-page "save for later" list.

   Phase 1: device-local (localStorage). Phase 2 swaps `adapter` for the
   synced backend (woodenbeast app proxy + customer metafield) — the
   public API and every UI file stay unchanged.

   Entry shape: { handle, variantId|null, qty|null,
                  source: 'wishlist' | 'sfl', addedAt }
   Identity:    wishlist = one per product (keyed by handle);
                sfl      = exact cart line (keyed by variantId).
   ===================================================================== */
(function () {
  'use strict';

  if (window.BWSaved) return;

  var STORAGE_KEY = 'bw:saved:v1';
  var MAX_ITEMS = 100;
  var listeners = [];

  /* The ONLY place that touches persistence — Phase 2 replaces this. */
  var adapter = {
    read: function () {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.filter(isValidEntry) : [];
      } catch (err) {
        return [];
      }
    },
    write: function (list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (err) {
        /* quota/private mode — the in-memory copy still works this page */
      }
    }
  };

  function isValidEntry(entry) {
    if (!entry || typeof entry.handle !== 'string' || !entry.handle) return false;
    return entry.source === 'wishlist' || entry.source === 'sfl';
  }

  function keyOf(entry) {
    return entry.source === 'sfl' ? 'sfl:' + entry.variantId : 'wish:' + entry.handle;
  }

  function emit(list) {
    listeners.forEach(function (fn) {
      try { fn(list); } catch (err) { /* one bad listener never blocks the rest */ }
    });
  }

  function save(list) {
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    adapter.write(list);
    emit(list);
    return list;
  }

  var api = {
    list: function (source) {
      var all = adapter.read();
      if (!source) return all;
      return all.filter(function (e) { return e.source === source; });
    },

    has: function (source, ref) {
      return api.list(source).some(function (e) {
        return source === 'sfl'
          ? String(e.variantId) === String(ref)
          : e.handle === ref;
      });
    },

    add: function (entry) {
      if (!isValidEntry(entry)) return adapter.read();
      var fresh = {
        handle: entry.handle,
        variantId: entry.variantId || null,
        qty: entry.qty || null,
        source: entry.source,
        addedAt: new Date().toISOString()
      };
      var list = adapter.read().filter(function (e) { return keyOf(e) !== keyOf(fresh); });
      list.unshift(fresh);
      return save(list);
    },

    remove: function (source, ref) {
      return save(adapter.read().filter(function (e) {
        if (e.source !== source) return true;
        return source === 'sfl'
          ? String(e.variantId) !== String(ref)
          : e.handle !== ref;
      }));
    },

    subscribe: function (fn) {
      listeners.push(fn);
      fn(adapter.read());
    }
  };

  window.BWSaved = api;

  /* Cross-tab: another tab changed the list → re-emit here. */
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) emit(adapter.read());
  });

  /* Header heart count — own attribute + textContent only; completely
     independent of the cart badge's data-attr/::after machinery. */
  function updateHeaderCount(list) {
    var n = list.filter(function (e) { return e.source === 'wishlist'; }).length;
    document.querySelectorAll('[data-bw-wish-count]').forEach(function (el) {
      el.textContent = n > 0 ? ' (' + n + ')' : '';
    });
  }

  function start() { api.subscribe(updateHeaderCount); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
